// Imports ------------------------------------------------------------------->

// Private Definitions ------------------------------------------------------->

class Icons {
    get trash() {
        return (
            <svg viewBox="0 0 1792 1792" focusable="false">
                <circle cx="896" cy="896" r="600" />
                <g transform="scale(0.5 0.5) translate(896 896)">
                    <path d="M704 736v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h64q14 0 23 9t9 23zm256 0v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h64q14 0 23 9t9 23zm256 0v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h64q14 0 23 9t9 23zm128 724v-948h-896v948q0 22 7 40.5t14.5 27 10.5 8.5h832q3 0 10.5-8.5t14.5-27 7-40.5zm-672-1076h448l-48-117q-7-9-17-11h-317q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z" />
                </g>
            </svg>
        )
    }

    get searchClose() {
        return (
            <svg viewBox="0 0 23 23" focusable="false">
                <g>
                    <rect
                        x="1.4"
                        y="10"
                        transform="matrix(0.7071 0.7071 -0.7071 0.7071 11.4976 -4.7625)"
                        width="20.1"
                        height="3"
                    />
                    <rect
                        x="1.4"
                        y="10"
                        transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 27.7577 11.4976)"
                        width="20.1"
                        height="3"
                    />
                </g>
            </svg>
        )
    }

    get info() {
        return (
            <svg viewBox="0 0 1792 1792">
                <path d="M1152 1376v-160q0-14-9-23t-23-9h-96v-512q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v160q0 14 9 23t23 9h96v320h-96q-14 0-23 9t-9 23v160q0 14 9 23t23 9h448q14 0 23-9t9-23zm-128-896v-160q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v160q0 14 9 23t23 9h192q14 0 23-9t9-23zm640 416q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" />
            </svg>
        )
    }

    get info2() {
        return (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g>
                    <path
                        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                        stroke="#0F72EA"
                        stroke-width="2"
                        stroke-miterlimit="10"
                    />
                    <path
                        d="M12 11V16"
                        stroke="#0F72EA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9Z"
                        fill="#0F72EA"
                    />
                </g>
            </svg>
        )
    }

    get warning() {
        return (
            <svg viewBox="0 0 1792 1792" focusable="false">
                <path d="M1024 1375v-190q0-14-9.5-23.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 23.5v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5zm-2-374l18-459q0-12-10-19-13-11-24-11h-220q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5t10.5-16.5zm-14-934l768 1408q35 63-2 126-17 29-46.5 46t-63.5 17h-1536q-34 0-63.5-17t-46.5-46q-37-63-2-126l768-1408q17-31 47-49t65-18 65 18 47 49z" />
            </svg>
        )
    }

    get deals() {
        return (
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path
                    d="M17.62 8.72996C16.3493 7.1439 15.4536 5.29103 15 3.30996C14.9672 3.14031 14.891 2.98205 14.7789 2.85061C14.6667 2.71916 14.5224 2.61903 14.36 2.55996C14.1942 2.4952 14.014 2.47589 13.8382 2.50401C13.6625 2.53214 13.4974 2.60669 13.36 2.71996C13.16 2.88996 8.93 6.37996 8.12 11.04C7.62278 10.6586 7.15172 10.2444 6.71 9.79996C6.60272 9.69135 6.472 9.60875 6.32785 9.55847C6.1837 9.5082 6.02996 9.4916 5.87841 9.50994C5.72685 9.52828 5.5815 9.58108 5.45351 9.66428C5.32552 9.74749 5.21827 9.8589 5.14 9.98996C4.39677 11.3774 4.00533 12.926 4 14.5C4 16.6217 4.84285 18.6565 6.34315 20.1568C7.84344 21.6571 9.87827 22.5 12 22.5C14.1217 22.5 16.1566 21.6571 17.6569 20.1568C19.1571 18.6565 20 16.6217 20 14.5C20 12.11 18.79 10.39 17.62 8.72996ZM13.76 19.73C13.2931 20.1965 12.66 20.4586 12 20.4586C11.34 20.4586 10.7069 20.1965 10.24 19.73C10.0068 19.5024 9.82191 19.2301 9.69647 18.9294C9.57103 18.6287 9.5076 18.3058 9.51 17.98C9.50448 17.6522 9.56644 17.3268 9.69203 17.0241C9.81761 16.7213 10.0041 16.4476 10.24 16.22L12 14.5L13.76 16.26C13.9951 16.4861 14.1812 16.7581 14.3068 17.0591C14.4324 17.3602 14.4947 17.6838 14.49 18.01C14.4937 18.3375 14.431 18.6623 14.3055 18.9648C14.18 19.2674 13.9944 19.5413 13.76 19.77V19.73Z"
                    fill="#D64B62"
                />
            </svg>
        )
    }

    get search() {
        return (
            <svg viewBox="0 0 2048 2048" focusable="false" class="search-icon">
                <path d="M1344 960q0-185-131.5-316.5t-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5 316.5-131.5 131.5-316.5zm512 832q0 52-38 90t-90 38q-54 0-90-38l-343-342q-179 124-399 124-143 0-273.5-55.5t-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5 273.5 55.5 225 150 150 225 55.5 273.5q0 220-124 399l343 343q37 37 37 90z" />
            </svg>
        )
    }

    get magnifier() {
        return (
            <svg viewBox="0 0 24 24" fill="none" class="search-icon">
                <path
                    d="M10 18C8.41775 18 6.87103 17.5308 5.55544 16.6518C4.23985 15.7727 3.21447 14.5233 2.60897 13.0615C2.00347 11.5997 1.84504 9.99113 2.15372 8.43928C2.4624 6.88743 3.22433 5.46197 4.34315 4.34315C5.46197 3.22433 6.88743 2.4624 8.43928 2.15372C9.99113 1.84504 11.5997 2.00347 13.0615 2.60897C14.5233 3.21447 15.7727 4.23985 16.6518 5.55544C17.5308 6.87103 18 8.41775 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18ZM10 4C8.81332 4 7.65328 4.3519 6.66658 5.01119C5.67989 5.67047 4.91085 6.60755 4.45673 7.7039C4.0026 8.80026 3.88378 10.0067 4.11529 11.1705C4.3468 12.3344 4.91825 13.4035 5.75736 14.2426C6.59648 15.0818 7.66558 15.6532 8.82946 15.8847C9.99335 16.1162 11.1997 15.9974 12.2961 15.5433C13.3925 15.0892 14.3295 14.3201 14.9888 13.3334C15.6481 12.3467 16 11.1867 16 10C16 8.4087 15.3679 6.88258 14.2426 5.75736C13.1174 4.63214 11.5913 4 10 4Z"
                    fill="#1F2833"
                />
                <path
                    d="M20.9999 21.9999C20.8683 22.0007 20.7378 21.9754 20.616 21.9257C20.4942 21.8759 20.3834 21.8026 20.2899 21.7099L14.6799 16.0899C14.5161 15.8986 14.4305 15.6525 14.4402 15.4009C14.4499 15.1492 14.5543 14.9104 14.7323 14.7323C14.9104 14.5543 15.1492 14.4499 15.4009 14.4402C15.6525 14.4305 15.8986 14.5161 16.0899 14.6799L21.7099 20.2899C21.8036 20.3829 21.878 20.4935 21.9288 20.6153C21.9796 20.7372 22.0057 20.8679 22.0057 20.9999C22.0057 21.1319 21.9796 21.2626 21.9288 21.3845C21.878 21.5063 21.8036 21.6169 21.7099 21.7099C21.6165 21.8026 21.5057 21.8759 21.3838 21.9257C21.262 21.9754 21.1315 22.0007 20.9999 21.9999Z"
                    fill="#1F2833"
                />
            </svg>
        )
    }

    get backArrow() {
        return (
            <svg
                focusable="false"
                viewBox="974 -974 2048 2048"
                class="back-icon"
            >
                <path d="M2453-481L1922,50l531,531c12.7,12.7,19,27.7,19,45s-6.3,32.3-19,45l-166,166c-12.7,12.7-27.7,19-45,19s-32.3-6.3-45-19 L1455,95c-12.7-12.7-19-27.7-19-45s6.3-32.3,19-45l742-742c12.7-12.7,27.7-19,45-19s32.3,6.3,45,19l166,166c12.7,12.7,19,27.7,19,45 C2472-508.7,2465.7-493.7,2453-481z" />
            </svg>
        )
    }

    get downArrow() {
        return (
            <svg
                focusable="false"
                viewBox="974 -974 2048 2048"
                class="back-icon"
            >
                <path d="m 1455,-471 531,531 531,-531 c 12.7,-12.7 27.7,-19 45,-19 17.3,0 32.3,6.3 45,19 l 166,166 c 12.7,12.7 19,27.7 19,45 0,17.3 -6.3,32.3 -19,45 l -742,742 c -12.7,12.7 -27.7,19 -45,19 -17.3,0 -32.3,-6.3 -45,-19 l -742,-742 c -12.7,-12.7 -19,-27.7 -19,-45 0,-17.3 6.3,-32.3 19,-45 l 166,-166 c 12.7,-12.7 27.7,-19 45,-19 17.3,0 32.3,6.3 45,19 z" />
            </svg>
        )
    }

    get chevronUp() {
        return (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                    d="M8.00012 4.66668C8.15901 4.66667 8.31269 4.72341 8.43345 4.82668L13.1001 8.82668C13.3799 9.06601 13.4128 9.48686 13.1735 9.76668C12.9341 10.0465 12.5133 10.0793 12.2335 9.84002L8.00012 6.21335L3.76678 9.84002C3.58577 9.99483 3.33591 10.0413 3.11133 9.96196C2.88675 9.8826 2.72156 9.68946 2.678 9.45529C2.63443 9.22112 2.7191 8.9815 2.90012 8.82668L7.56678 4.82668C7.68755 4.72341 7.84122 4.66667 8.00012 4.66668Z"
                    fill="#1F2833"
                />
            </svg>
        )
    }

    get chevronDown() {
        return (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                    d="M7.99988 11.3334C7.84099 11.3334 7.68731 11.2766 7.56655 11.1734L2.89988 7.17338C2.62006 6.93406 2.58723 6.5132 2.82655 6.23338C3.06587 5.95355 3.48673 5.92072 3.76655 6.16005L7.99988 9.78671L12.2332 6.16005C12.4142 6.00523 12.6641 5.95875 12.8887 6.0381C13.1132 6.11746 13.2784 6.3106 13.322 6.54477C13.3656 6.77894 13.2809 7.01856 13.0999 7.17338L8.43322 11.1734C8.31245 11.2766 8.15878 11.3334 7.99988 11.3334Z"
                    fill="#1F2833"
                />
            </svg>
        )
    }

    get hamburger() {
        return (
            <svg width="21" height="15" viewBox="0 0 21 15" fill="none">
                <rect width="21" height="3" rx="1.5" fill="#1F2833" />
                <rect y="6" width="21" height="3" rx="1.5" fill="#1F2833" />
                <rect y="12" width="21" height="3" rx="1.5" fill="#1F2833" />
            </svg>
        )
    }

    get flippLogo() {
        return (
            <svg focusable="false" viewBox="0 0 2048 1436" class="flipp-logo">
                <path d="M682.8,786.2c16.9,51.4,96.4,69.5,141.7,40c10.9-7.1,20.2-18.5,27.7-30.5c6.8-10.9-5-24-16.5-18.2 c-1.6,0.8-3.2,1.6-4.9,2.3c-20.8,9.1-33.1-1.8-26.9-23.7c0.6-2,1.2-4.4,2.1-7.4c30.9-113.7,65.2-226.5,85.7-299.2 c2.6-9.4-5.7-18.1-15.2-15.8L766.5,455c-4.5,1.1-8.1,4.4-9.3,8.8c-12.6,43.8-36,136.4-68.9,233.4 C675.3,735.5,675.6,764.4,682.8,786.2z" />
                <circle cx="860.9" cy="337.8" r="63" />
                <path d="M684.6,302.3l-109.9,21.3c-4.5,1.1-8.1,4.4-9.3,8.8c-12.6,43.8-74,265.7-106.9,362.7 c-12.9,38.2-12.7,67.2-5.5,89c16.9,51.4,95.4,71.3,140.7,41.7c15.3-10,22.4-22.3,25.6-32.6c2.4-7.7-4.8-14.9-12.5-12.5 c-4.9,1.5-11.4,3-19.8,4.3c-8.4,1.2-16-5.1-16.3-13.5c-0.3-8.2,0.3-8.4,4.4-23.2c30.9-113.7,104.2-357.6,124.7-430.2 C702.5,308.7,694.1,300,684.6,302.3z" />
                <path d="M311.7,566.6c1.4-4.4,2.9-8.8,4.4-13.3l111.8-21.6c5.3-1,9.6-4.8,11.3-10l21.9-66.8 c3.5-10.8-5.8-21.4-17-19.3l-96.5,18.7c33.1-105.1,69.2-217.4,98.8-264.7c55.5-88.6,117.6-49.4,125.1-44.2 c-24,8.9-41.2,31.9-41.2,59c0,34.1,20.1,62.6,69.7,62.6c63.9,0,97.7-49.8,97.7-102.1c0-68.7-54.3-111.4-128.8-129.7 c-95-23.3-199.4,18.5-249.1,100.8c-33.8,56-83.8,217.9-114.9,325.8l-0.2-0.2c-1.1,3.9-3.2,11.2-6.2,21.4l-139.4,27 c-5.3,1-9.6,4.8-11.3,10l-21.9,66.8c-3.5,10.8,5.8,21.4,17,19.3L170,581.6l-16.4,56.3c-43.2,148.3-101.6,346.9-127.3,427 c-2.6,8.2,4.7,16.1,13.1,14.1l18.6-4.5c67.8-16.3,121.8-67.4,141.7-134.2c12.2-41.1,60.9-206.4,88.5-300.4L311.7,566.6z" />
                <path d="M1411.7,955c0.7-2,39.8-131.9,39.8-131.9s12.7,46.6,87.9,46.6c74.6,0,183-46.6,218.4-176.8 c36.1-132.7,16.7-227.2-70.7-255.1c-57.2-19.9-138.2,43.5-138.2,43.5c3.6-12.7,8.5-25.3,10.9-33.7c2.6-9.4-5.7-18.1-15.2-15.8 l-113.7,21.1c-4.5,1.1-8.1,4.4-9.3,8.8c-9.1,31.6-86.8,299.5-140.2,477.9C1321.5,945.2,1363.4,950.5,1411.7,955z M1529,551.2 c30.2-31.5,65.5-46,94-34.2c45.1,18.7,55.8,96.4,23.8,173.5c-32,77.1-94.5,124.4-139.6,105.7c-16.9-7-29-22.3-35.8-42.7L1529,551.2 z" />
                <path d="M990.6,898.2c12.2-40.9,22.4-75.1,22.4-75.1s12.7,46.6,87.9,46.6c74.6,0,183-46.6,218.4-176.8 c36.1-132.7,16.7-227.2-70.7-255.1c-57.2-19.9-138.2,43.5-138.2,43.5c3.6-12.7,8.5-25.3,10.9-33.7c2.6-9.4-5.8-18.1-15.2-15.8 l-113.7,21.1c-4.5,1.1-8.1,4.4-9.3,8.8c-8.4,29-71.6,248-123.3,422.1C903.7,887.3,946.8,892.8,990.6,898.2z M1090.5,551.2 c30.2-31.5,65.5-46,94-34.2c45.1,18.7,55.8,96.4,23.8,173.5c-32,77.1-94.5,124.4-139.6,105.7c-16.9-7-29-22.3-35.8-42.7 L1090.5,551.2z" />
                <path d="M1943.4,873.2c0,0-9.5-2.9-18.6,8.9c-27.1,35.3-103.3,107.6-277.9,121.1c-210.3,16.3-469.6-38.3-617.7-56.3 c-150.7-18.3-370.3-72.6-626.1,17.3C230.4,1025,192.5,1167.3,221,1264.1c36.6,124.4,249.8,165.4,375.5,131.7 c126.2-33.8,270.3-126,333.3-286l-131.1-16.2c0,0-81.3,144.8-220.7,189.5c-121.6,39-239.9-13.4-234.7-76.4 c8.1-98.2,160.3-215.2,667.7-129.7c295.2,49.7,526.7,64.8,634.3,64.8c306.8,0,368.8-78.8,368.8-78.8S2059.6,930.7,1943.4,873.2z" />
            </svg>
        )
    }

    get flippLogoWhite() {
        return (
            <svg viewBox="0 0 141 109">
                <path
                    d="M59.9535 55.0238C60.6443 57.1361 63.9111 57.8734 65.7715 56.6677C66.234 56.3366 66.6216 55.9118 66.9091 55.4209C66.9628 55.3236 66.9848 55.2119 66.972 55.1015C66.9592 54.9911 66.9124 54.8874 66.8379 54.8049C66.7635 54.7224 66.6652 54.6651 66.5567 54.6412C66.4482 54.6172 66.3349 54.6277 66.2326 54.6711C66.1667 54.705 66.0991 54.737 66.0314 54.7673C65.1751 55.1413 64.6731 54.6925 64.9241 53.7931C64.9472 53.7111 64.9739 53.615 65.0078 53.4885C66.2789 48.8186 67.6782 44.1826 68.5256 41.1993C68.5505 41.1115 68.5519 41.0187 68.5298 40.9301C68.5077 40.8415 68.4629 40.7603 68.3998 40.6944C68.3366 40.6285 68.2573 40.5803 68.1698 40.5545C68.0823 40.5287 67.9895 40.5263 67.9008 40.5474L63.3895 41.4255C63.2997 41.4452 63.2168 41.4887 63.1495 41.5513C63.0822 41.614 63.0329 41.6935 63.0067 41.7817C62.4886 43.5806 61.5273 47.376 60.1742 51.3691C59.6402 52.9399 59.6597 54.1279 59.9535 55.0238Z"
                    fill="white"
                />
                <path
                    d="M68.7772 38.7046C69.9362 37.869 70.1987 36.2516 69.3634 35.0921C68.5281 33.9326 66.9114 33.6701 65.7524 34.5057C64.5934 35.3414 64.3309 36.9588 65.1662 38.1182C66.0015 39.2777 67.6182 39.5403 68.7772 38.7046Z"
                    fill="white"
                />
                <path
                    d="M60.0283 35.1436L55.517 36.0198C55.4272 36.0402 55.3444 36.0838 55.2769 36.1463C55.2094 36.2089 55.1596 36.2881 55.1324 36.3761C54.6161 38.1749 52.0934 47.2885 50.7458 51.2745C50.2117 52.8454 50.2259 54.0333 50.5197 54.931C51.2104 57.0415 54.4363 57.859 56.2967 56.6444C56.795 56.3375 57.1679 55.8634 57.3489 55.3068C57.3715 55.2354 57.3742 55.1591 57.3565 55.0863C57.3388 55.0135 57.3015 54.9469 57.2486 54.8938C57.1958 54.8407 57.1293 54.8032 57.0566 54.7852C56.9839 54.7673 56.9077 54.7697 56.8362 54.7921C56.5699 54.8719 56.2979 54.9314 56.0226 54.9702C55.9414 54.9825 55.8584 54.9776 55.7793 54.9556C55.7001 54.9336 55.6265 54.8951 55.5632 54.8426C55.5 54.7901 55.4486 54.7248 55.4124 54.651C55.3762 54.5772 55.356 54.4966 55.3532 54.4145C55.3425 54.0761 55.3674 54.0707 55.5312 53.4598C56.8006 48.7917 59.8039 38.7716 60.6514 35.7883C60.6751 35.7011 60.6757 35.6091 60.6532 35.5216C60.6307 35.434 60.5858 35.3538 60.523 35.2888C60.4602 35.2237 60.3815 35.1762 60.2948 35.1507C60.2081 35.1253 60.1162 35.1228 60.0283 35.1436Z"
                    fill="white"
                />
                <path
                    d="M44.7159 46.0044L44.8939 45.4576L49.4817 44.5671C49.5891 44.5464 49.689 44.4974 49.771 44.425C49.8531 44.3527 49.9142 44.2597 49.9482 44.1557L50.8472 41.4111C50.8805 41.3097 50.8867 41.2014 50.8652 41.0969C50.8438 40.9923 50.7954 40.8952 50.7249 40.8151C50.6544 40.7351 50.5642 40.6748 50.4632 40.6403C50.3623 40.6058 50.2541 40.5983 50.1494 40.6185L46.1864 41.3862C47.5466 37.0689 49.026 32.4578 50.2437 30.5218C52.5207 26.8813 55.0719 28.4914 55.3799 28.7051C54.8839 28.888 54.4558 29.2185 54.1534 29.6523C53.851 30.086 53.6888 30.6021 53.6886 31.1309C53.6886 32.5308 54.5147 33.7027 56.5531 33.7027C59.1773 33.7027 60.5623 31.6545 60.5623 29.5102C60.5623 26.6872 58.3352 24.9329 55.2749 24.183C51.3742 23.2248 47.0855 24.9436 45.0488 28.3258C43.6602 30.6251 41.6092 37.2773 40.3274 41.7085L40.0693 42.567L34.3438 43.6766C34.237 43.6976 34.1378 43.7466 34.0561 43.8185C33.9745 43.8905 33.9134 43.9829 33.8792 44.0862L32.9783 46.8415C32.9455 46.9428 32.9396 47.0509 32.9612 47.1552C32.9829 47.2594 33.0313 47.3563 33.1018 47.4361C33.1722 47.5159 33.2623 47.576 33.363 47.6104C33.4637 47.6448 33.5717 47.6524 33.6762 47.6323L38.8978 46.6224L38.2249 48.9378C36.4446 55.029 34.0536 63.1862 32.9997 66.4811C32.9752 66.5574 32.9714 66.6388 32.9886 66.7171C33.0059 66.7953 33.0436 66.8676 33.0979 66.9264C33.1522 66.9853 33.2212 67.0287 33.2978 67.0522C33.3744 67.0756 33.4558 67.0783 33.5338 67.0599L34.2975 66.8818C35.6657 66.5549 36.9236 65.8733 37.9449 64.9057C38.9663 63.938 39.7149 62.7184 40.1156 61.3695C40.6176 59.6811 42.608 52.8882 43.7492 49.0286L44.7159 46.0044Z"
                    fill="white"
                />
                <path
                    d="M89.9943 61.6029C90.0228 61.5209 90.0531 61.4408 90.078 61.3571C90.7901 58.9633 91.5165 56.5482 91.5165 56.5482C91.5165 56.5482 92.0417 58.454 95.1251 58.454C98.2086 58.454 102.638 56.5411 104.094 51.1909C105.579 45.7409 104.782 41.8564 101.191 40.7094C98.8424 39.8955 95.5133 42.4905 95.5133 42.4905C95.6628 41.9686 95.8693 41.4503 95.9601 41.1066C95.9845 41.0189 95.9857 40.9263 95.9634 40.838C95.9412 40.7497 95.8963 40.6687 95.8332 40.6031C95.7701 40.5374 95.691 40.4894 95.6036 40.4637C95.5163 40.438 95.4238 40.4355 95.3352 40.4565L90.6655 41.3256C90.5757 41.3454 90.4928 41.3888 90.4255 41.4515C90.3582 41.5141 90.3089 41.5937 90.2827 41.6819C89.9088 42.982 86.82 53.6683 84.6285 60.9973C86.2806 61.2377 88.0912 61.4461 89.9943 61.6029ZM94.7014 45.3704C95.9476 44.0756 97.3933 43.4825 98.5611 43.9669C100.413 44.7346 100.851 47.9262 99.5385 51.0911C98.2264 54.256 95.661 56.2045 93.8077 55.4351C93.1134 55.1483 92.6167 54.5196 92.3372 53.679L94.7014 45.3704Z"
                    fill="white"
                />
                <path
                    d="M72.6043 59.5743C73.1064 57.893 73.5123 56.5465 73.5123 56.5465C73.5123 56.5465 74.0339 58.4594 77.1192 58.4594C80.2044 58.4594 84.6321 56.5465 86.0883 51.1962C87.5731 45.7462 86.7755 41.8618 83.1847 40.7148C80.8364 39.9008 77.5091 42.4958 77.5091 42.4958C77.6586 41.974 77.8651 41.4557 77.9541 41.1119C77.9786 41.0242 77.9797 40.9316 77.9575 40.8433C77.9352 40.755 77.8903 40.6741 77.8272 40.6084C77.7641 40.5428 77.685 40.4947 77.5977 40.469C77.5103 40.4433 77.4178 40.4409 77.3292 40.4619L72.6595 41.331C72.5699 41.3513 72.4873 41.3949 72.4201 41.4575C72.3529 41.5201 72.3034 41.5993 72.2767 41.6872C71.9331 42.8805 69.3624 51.7858 67.2385 58.9402C69.0758 59.0667 70.8561 59.4176 72.6043 59.5743ZM76.699 45.3704C77.9452 44.0756 79.3891 43.4825 80.5569 43.967C82.4102 44.7346 82.8482 47.9262 81.5361 51.0912C80.224 54.2561 77.6568 56.2046 75.8035 55.4351C75.1092 55.1484 74.6143 54.5197 74.3348 53.679L76.699 45.3704Z"
                    fill="white"
                />
                <path
                    d="M111.719 58.5965C111.719 58.5965 111.329 58.4772 110.957 58.9616C109.845 60.4132 106.717 63.3839 99.5439 63.9396C90.9076 64.6075 82.5918 62.7535 76.4373 62.1034C70.2383 61.4479 59.2218 58.9331 48.0753 63.0936C41.0306 65.7242 39.82 70.6809 40.9897 74.6562C42.494 79.7678 51.2496 81.4526 56.4107 80.0688C61.5718 78.6849 67.5091 74.8913 70.0959 68.3139L64.7158 67.6478C64.7158 67.6478 61.3759 73.5982 55.6523 75.4327C50.6585 77.0356 45.8001 74.8824 46.0137 72.2963C46.3466 68.2622 52.6008 63.4552 73.4304 66.9692C85.5507 69.0174 95.0682 69.639 99.4762 69.639C112.075 69.639 114.619 66.4046 114.619 66.4046C114.619 66.4046 116.492 60.9617 111.719 58.5965Z"
                    fill="white"
                />
            </svg>
        )
    }

    get eye() {
        return (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21 12C21 12 17 17 12 17C7 17 3 12 3 12C3 12 7 7 12 7C17 7 21 12 21 12Z"
                    stroke="#8493A6"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="2"
                    stroke="#8493A6"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        )
    }

    get myDiscoverSl() {
        return (
            <svg
                width="55px"
                height="55px"
                id="Layer_1"
                viewBox="0 0 88.8 64.9"
            >
                <g fill="#29bfd1">
                    <circle cx="46.1" cy="32.4" r="32.4" opacity=".22" />
                    <circle cx="46.1" cy="32.4" r="24.2" opacity=".4" />
                </g>
                <path
                    fill="#fdbd10"
                    class="st2"
                    d="M85.7 34.9c-1.7 0-3-1.4-3-3 0-1.7 1.4-3 3-3 1.7 0 3 1.4 3 3 .1 1.7-1.3 3-3 3zm0-4.9c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM71 6.7c-1.7 0-3-1.4-3-3s1.4-3 3-3c1.7 0 3 1.4 3 3s-1.3 3-3 3zm0-4.9c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                />
                <circle fill="#29bfd1" class="st3" cx="8.3" cy="38.7" r="1.2" />
                <path
                    fill="#29bfd1"
                    class="st3"
                    d="M7.1 31.7c-1.7 0-3-1.4-3-3 0-1.7 1.4-3 3-3 1.7 0 3 1.4 3 3s-1.4 3-3 3zm0-5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-1-2-2-2z"
                />
                <circle fill="#29bfd1" class="st3" cx="78.6" cy="5" r="1.2" />
                <circle
                    fill="#fdbd10"
                    class="st2"
                    cx="14.9"
                    cy="12.6"
                    r="1.2"
                />
                <path
                    fill="#fdbd10"
                    class="st2"
                    d="M80 11.1h-1.1V10c0-.2-.2-.4-.4-.4s-.4.2-.4.4v1.1H77c-.2 0-.4.2-.4.4s.2.4.4.4h1.1V13c0 .2.2.4.4.4s.4-.2.4-.4v-1.1H80c.2 0 .4-.2.4-.4s-.2-.4-.4-.4zM3.3 33H2.2v-1.1c0-.2-.2-.4-.4-.4s-.4.2-.4.4V33h-1c-.2 0-.4.2-.4.4s.2.4.4.4h1.1v1.1c0 .2.2.4.4.4s.4-.2.4-.4v-1.1h1.1c.2 0 .4-.2.4-.4s-.3-.4-.5-.4z"
                />
                <path
                    fill="#29bfd1"
                    class="st3"
                    d="M84.7 39.7h-1.1v-1.1c0-.2-.2-.4-.4-.4s-.4.2-.4.4v1.1h-1.1c-.2 0-.4.2-.4.4s.2.4.4.4h1.1v1.1c0 .2.2.4.4.4s.4-.2.4-.4v-1.1h1.1c.2 0 .4-.2.4-.4s-.2-.4-.4-.4z"
                />
                <g>
                    <path fill="#fff" d="M27 11.8h34v46.5H27z" />
                    <path fill="#d1e2f4" d="M27 43.9h34v14H27z" />
                    <path
                        fill="none"
                        stroke="#5f5271"
                        stroke-width="2"
                        stroke-miterlimit="10"
                        d="M26.8 11.7H62v47H26.8z"
                    />
                    <path
                        fill="none"
                        stroke="#5f5271"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        class="st7"
                        d="M56.2 13s.1-2.8-.2-3.4c-.3-.6-.8-1-1.6-1s-1.2.4-1.5 1c-.3.7-.2 1.5-.2 1.5M49.2 12.9s.1-2.8-.2-3.4c-.3-.6-.8-1-1.6-1s-1.2.4-1.5 1c-.3.7-.2 1.5-.2 1.5M42.1 12.8s.1-2.8-.2-3.4-.8-1-1.6-1-1.2.4-1.5 1c-.3.7-.2 1.5-.2 1.5M35.3 12.8s.1-2.8-.2-3.4-.8-1-1.6-1-1.2.4-1.5 1c-.3.7-.2 1.5-.2 1.5"
                    />
                    <g>
                        <path
                            fill="#5f5271"
                            class="st8"
                            d="M40.7 22.9v.3s-.1 4.8 4.1 4.8c4 0 4.1-4.7 4.1-4.8v-.3h-8.2z"
                        />
                        <path
                            d="M44.8 24.7c-1.3 0-2.3.6-2.7 1.5.3.8 1.3 1.5 2.6 1.4 1.3 0 2.3-.6 2.7-1.5-.3-.8-1.3-1.4-2.6-1.4z"
                            fill="#f0bbd6"
                        />
                        <ellipse
                            fill="#5f5271"
                            transform="rotate(-1.794 50.098 20.703) scale(.99999)"
                            class="st8"
                            cx="50.1"
                            cy="20.7"
                            rx="1.6"
                            ry="1.8"
                        />
                        <ellipse
                            fill="#5f5271"
                            transform="rotate(-1.794 39.9 20.703) scale(.99999)"
                            class="st8"
                            cx="39.9"
                            cy="20.7"
                            rx="1.6"
                            ry="1.8"
                        />
                    </g>
                    <g>
                        <path
                            fill="none"
                            stroke="#5f5271"
                            stroke-miterlimit="10"
                            class="st10"
                            d="M31.7 31.5h4.8v4.8h-4.8z"
                        />
                        <path
                            fill="#5f5271"
                            class="st8"
                            d="M39 32.4h18v1H39zM39 34.9h13v1H39z"
                        />
                        <path
                            fill="none"
                            stroke="#5f5271"
                            stroke-miterlimit="10"
                            class="st10"
                            d="M31.7 39.5h4.8v4.8h-4.8z"
                        />
                        <path
                            fill="#5f5271"
                            class="st8"
                            d="M39 40.4h18v1H39zM39 42.9h13v1H39z"
                        />
                        <path
                            fill="none"
                            stroke="#5f5271"
                            stroke-miterlimit="10"
                            class="st10"
                            d="M31.7 47.5h4.8v4.8h-4.8z"
                        />
                        <path
                            fill="#5f5271"
                            class="st8"
                            d="M39 48.4h18v1H39zM39 50.9h13v1H39z"
                        />
                        <path
                            fill="#fdbd10"
                            class="st2"
                            d="M33 32.9h2v2h-2zM33 40.9h2v2h-2zM33 48.9h2v2h-2z"
                        />
                    </g>
                </g>
            </svg>
        )
    }

    get zoomIn() {
        return (
            <svg viewBox="0 0 1792 1792" focusable="false">
                <path d="M1600 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z" />
            </svg>
        )
    }

    get zoomOut() {
        return (
            <svg viewBox="0 0 1792 1792" focusable="false">
                <path d="M1600 736v192q0 40-28 68t-68 28h-1216q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h1216q40 0 68 28t28 68z" />
            </svg>
        )
    }

    get leftArrow() {
        return (
            <svg focusable="false" viewBox="974 -974 2048 2048">
                <path d="M2453-481L1922,50l531,531c12.7,12.7,19,27.7,19,45s-6.3,32.3-19,45l-166,166c-12.7,12.7-27.7,19-45,19s-32.3-6.3-45-19 L1455,95c-12.7-12.7-19-27.7-19-45s6.3-32.3,19-45l742-742c12.7-12.7,27.7-19,45-19s32.3,6.3,45,19l166,166c12.7,12.7,19,27.7,19,45 C2472-508.7,2465.7-493.7,2453-481z" />
            </svg>
        )
    }

    get rightArrow() {
        return (
            <svg focusable="false" viewBox="974 -974 2048 2048">
                <path d="M2537,95l-742,742c-12.7,12.7-27.7,19-45,19s-32.3-6.3-45-19l-166-166c-12.7-12.7-19-27.7-19-45s6.3-32.3,19-45l531-531 l-531-531c-12.7-12.7-19-27.7-19-45c0-17.3,6.3-32.3,19-45l166-166c12.7-12.7,27.7-19,45-19s32.3,6.3,45,19L2537,5 c12.7,12.7,19,27.7,19,45S2549.7,82.3,2537,95z" />
            </svg>
        )
    }

    get locationMarker() {
        return (
            <svg viewBox="0 0 1792 1792">
                <path d="M1152 640q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zm256 0q0 109-33 179l-364 774q-16 33-47.5 52t-67.5 19-67.5-19-46.5-52l-365-774q-33-70-33-179 0-212 150-362t362-150 362 150 150 362z" />
            </svg>
        )
    }

    get fullStar() {
        return (
            <svg viewBox="-192 -384 2048 2048" focusable="false">
                <g transform="scale(1 -1) translate(0 -1280)">
                    <path d="M1664 889q0 -22 -26 -48l-363 -354l86 -500q1 -7 1 -20q0 -21 -10.5 -35.5t-30.5 -14.5q-19 0 -40 12l-449 236l-449 -236q-22 -12 -40 -12q-21 0 -31.5 14.5t-10.5 35.5q0 6 2 20l86 500l-364 354q-25 27 -25 48q0 37 56 46l502 73l225 455q19 41 49 41t49 -41l225 -455 l502 -73q56 -9 56 -46z"></path>
                    <path
                        class="flipp-rating-outline"
                        d="M1137 532l306 297l-422 62l-189 382l-189 -382l-422 -62l306 -297l-73 -421l378 199l377 -199zM1664 889q0 -22 -26 -48l-363 -354l86 -500q1 -7 1 -20q0 -50 -41 -50q-19 0 -40 12l-449 236l-449 -236q-22 -12 -40 -12q-21 0 -31.5 14.5t-10.5 35.5q0 6 2 20l86 500 l-364 354q-25 27 -25 48q0 37 56 46l502 73l225 455q19 41 49 41t49 -41l225 -455l502 -73q56 -9 56 -46z"
                    ></path>
                </g>
            </svg>
        )
    }

    get halfStar() {
        return (
            <svg viewBox="-192 -384 2048 2048" focusable="false">
                <g transform="scale(1 -1) translate(0 -1280)">
                    <path
                        class="flipp-rating-empty"
                        d="M1664 889q0 -22 -26 -48l-363 -354l86 -500q1 -7 1 -20q0 -21 -10.5 -35.5t-30.5 -14.5q-19 0 -40 12l-449 236l-449 -236q-22 -12 -40 -12q-21 0 -31.5 14.5t-10.5 35.5q0 6 2 20l86 500l-364 354q-25 27 -25 48q0 37 56 46l502 73l225 455q19 41 49 41t49 -41l225 -455 l502 -73q56 -9 56 -46z"
                    ></path>
                    <path d="M832 1504v-1339l-449 -236q-22 -12 -40 -12q-21 0 -31.5 14.5t-10.5 35.5q0 6 2 20l86 500l-364 354q-25 27 -25 48q0 37 56 46l502 73l225 455q19 41 49 41z"></path>
                    <path
                        class="flipp-rating-outline"
                        d="M1137 532l306 297l-422 62l-189 382l-189 -382l-422 -62l306 -297l-73 -421l378 199l377 -199zM1664 889q0 -22 -26 -48l-363 -354l86 -500q1 -7 1 -20q0 -50 -41 -50q-19 0 -40 12l-449 236l-449 -236q-22 -12 -40 -12q-21 0 -31.5 14.5t-10.5 35.5q0 6 2 20l86 500 l-364 354q-25 27 -25 48q0 37 56 46l502 73l225 455q19 41 49 41t49 -41l225 -455l502 -73q56 -9 56 -46z"
                    ></path>
                </g>
            </svg>
        )
    }

    get emptyStar() {
        return (
            <svg viewBox="-192 -384 2048 2048" focusable="false">
                <g transform="scale(1 -1) translate(0 -1280)">
                    <path
                        class="flipp-rating-empty"
                        d="M1664 889q0 -22 -26 -48l-363 -354l86 -500q1 -7 1 -20q0 -21 -10.5 -35.5t-30.5 -14.5q-19 0 -40 12l-449 236l-449 -236q-22 -12 -40 -12q-21 0 -31.5 14.5t-10.5 35.5q0 6 2 20l86 500l-364 354q-25 27 -25 48q0 37 56 46l502 73l225 455q19 41 49 41t49 -41l225 -455 l502 -73q56 -9 56 -46z"
                    ></path>
                    <path
                        class="flipp-rating-outline"
                        d="M1137 532l306 297l-422 62l-189 382l-189 -382l-422 -62l306 -297l-73 -421l378 199l377 -199zM1664 889q0 -22 -26 -48l-363 -354l86 -500q1 -7 1 -20q0 -50 -41 -50q-19 0 -40 12l-449 236l-449 -236q-22 -12 -40 -12q-21 0 -31.5 14.5t-10.5 35.5q0 6 2 20l86 500 l-364 354q-25 27 -25 48q0 37 56 46l502 73l225 455q19 41 49 41t49 -41l225 -455l502 -73q56 -9 56 -46z"
                    ></path>
                </g>
            </svg>
        )
    }

    get x() {
        return (
            <svg viewBox="0 0 23 23" focusable="false">
                <g>
                    <rect
                        x="1.4"
                        y="10"
                        transform="matrix(0.7071 0.7071 -0.7071 0.7071 11.4976 -4.7625)"
                        width="20.1"
                        height="3"
                    />
                    <rect
                        x="1.4"
                        y="10"
                        transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 27.7577 11.4976)"
                        width="20.1"
                        height="3"
                    />
                </g>
            </svg>
        )
    }

    get warn() {
        return (
            <svg width="30" height="24" viewBox="0 0 30 24" fill="none">
                <path
                    d="M27.7502 23.3339H2.25025C1.99614 23.3335 1.74683 23.2647 1.52843 23.1348C1.31004 23.0049 1.1306 22.8187 1.00892 22.5956C0.887241 22.3725 0.827802 22.1208 0.836833 21.8669C0.845863 21.6129 0.92303 21.3661 1.06025 21.1522L13.8102 1.3189C13.9387 1.12008 14.1149 0.956598 14.3227 0.843402C14.5306 0.730205 14.7635 0.670898 15.0002 0.670898C15.2369 0.670898 15.4699 0.730205 15.6777 0.843402C15.8856 0.956598 16.0618 1.12008 16.1902 1.3189L28.9402 21.1522C29.0775 21.3661 29.1546 21.6129 29.1637 21.8669C29.1727 22.1208 29.1133 22.3725 28.9916 22.5956C28.8699 22.8187 28.6905 23.0049 28.4721 23.1348C28.2537 23.2647 28.0044 23.3335 27.7502 23.3339ZM4.84275 20.5006H25.1577L15.0002 4.70473L4.84275 20.5006Z"
                    fill="#990026"
                />
                <path
                    d="M15.0007 14.8332C14.6249 14.8332 14.2646 14.6839 13.9989 14.4182C13.7332 14.1526 13.584 13.7922 13.584 13.4165V10.5832C13.584 10.2074 13.7332 9.84711 13.9989 9.58144C14.2646 9.31576 14.6249 9.1665 15.0007 9.1665C15.3764 9.1665 15.7367 9.31576 16.0024 9.58144C16.2681 9.84711 16.4173 10.2074 16.4173 10.5832V13.4165C16.4173 13.7922 16.2681 14.1526 16.0024 14.4182C15.7367 14.6839 15.3764 14.8332 15.0007 14.8332Z"
                    fill="#990026"
                />
                <path
                    d="M15.0007 19.0833C15.7831 19.0833 16.4173 18.4491 16.4173 17.6667C16.4173 16.8843 15.7831 16.25 15.0007 16.25C14.2182 16.25 13.584 16.8843 13.584 17.6667C13.584 18.4491 14.2182 19.0833 15.0007 19.0833Z"
                    fill="#990026"
                />
            </svg>
        )
    }

    get roundedX() {
        return (
            <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1">
                <g stroke-linecap="round">
                    <g
                        transform="translate(1.000000, 1.000000)"
                        stroke-width="2"
                    >
                        <g>
                            <path d="M0.21220145,11.2896 L11.6710798,0.2304"></path>
                            <path
                                d="M0.21220145,11.2896 L11.6710798,0.2304"
                                transform="translate(5.941641, 5.760000) scale(-1, 1) translate(-5.941641, -5.760000) "
                            ></path>
                        </g>
                    </g>
                </g>
            </svg>
        )
    }

    get print() {
        return (
            <svg viewBox="0 0 22 22" focusable="false">
                <circle class="badge" fill="#83B146" cx="11" cy="11" r="11" />
                <path
                    class="printer"
                    fill="#fff"
                    d="M15.55,8.4h-9.1c-1.079,0-1.95,0.871-1.95,1.95v3.9h2.6v2.6h7.8v-2.6h2.6v-3.9,C17.5,9.271,16.629,8.4,15.55,8.4z M13.6,15.55H8.4V12.3h5.2V15.55z M15.55,11c-0.358,0-0.65-0.292-0.65-0.65s0.293-0.65,0.65-0.65,c0.357,0,0.65,0.293,0.65,0.65S15.907,11,15.55,11z M14.9,5.15H7.1v2.6h7.8V5.15z"
                />
            </svg>
        )
    }

    get noClippings() {
        return (
            <svg viewBox="0 0 222.7 194.7" focusable="false" version="1.1">
                <rect
                    x="111"
                    y="39.1"
                    transform="matrix(0.9816 -0.1908 0.1908 0.9816 -8.1467 26.4726)"
                    class="st0"
                    width="44.9"
                    height="32.9"
                />
                <rect
                    x="20"
                    y="23.5"
                    transform="matrix(0.9472 -0.3207 0.3207 0.9472 -13.0874 22.0742)"
                    class="st1"
                    width="81"
                    height="54.4"
                />
                <rect
                    x="131.9"
                    y="40.7"
                    transform="matrix(0.9607 0.2777 -0.2777 0.9607 25.6043 -44.3888)"
                    class="st2"
                    width="75.2"
                    height="55.1"
                />
                <g>
                    <path
                        class="st3"
                        d="M42.6,58.5c0.1-0.1,0.2-0.2,0.3-0.2c0.9-0.7,1.8-1.5,2.7-2.2c0.7-0.5,1.4-1,2.1-1.4c0.2-0.1,0.3-0.3,0.2-0.5 c-0.7-1.2-1.4-2.3-2.2-3.5c-1.4-2.2-2.7-4.4-4.1-6.6c-0.1-0.2-0.2-0.2-0.4-0.1c-0.6,0.5-1.2,1.1-1.8,1.6c-0.8,0.7-1.2,1.5-1,2.5 c0.2,1.2,0.5,2.4,0.9,3.6c0.8,2.3,1.8,4.5,3,6.6C42.4,58.4,42.5,58.4,42.6,58.5z"
                    />
                    <path
                        class="st4"
                        d="M73.2,57.3c-0.3-0.9-0.6-1.7-1-2.6c-0.4-1-0.8-2-1.1-3c-0.3-0.9-0.7-1.8-1-2.7c-0.3-0.9-0.7-1.8-1.1-2.8 c-0.5-1.3-1-2.6-1.5-3.9c-0.5-1.4-1-2.7-1.5-4.1c-0.7-1.8-1.4-3.7-2.1-5.5c-0.1-0.2-0.2-0.2-0.4-0.1C62.3,33,61,33.5,59.8,34 c-1.7,0.7-3.4,1.5-5.4,2.3c-1.6,0.8-3.4,1.8-5.2,2.8c-1.8,1-3.5,2-5.2,3.1c-0.2,0.1-0.2,0.2-0.1,0.4c0.5,0.8,1,1.6,1.5,2.4 c0.6,1,1.3,2.1,1.9,3.2c0.5,0.9,1.1,1.8,1.6,2.7c0.6,0.9,1.1,1.8,1.7,2.7c0.8,1.4,1.7,2.7,2.5,4.1c0.6,1.1,1.3,2.1,1.9,3.2 c0.5,0.9,1.1,1.7,1.6,2.6c0.6,1,1.3,1.9,1.8,3c0.4,0.7,0.9,1.1,1.8,1.1c0,0,0,0,0.1,0c1.7,0.1,3.4-0.3,5-1c2.2-0.8,4.3-1.9,6.2-3.4 c1-0.8,1.9-1.7,2.5-2.7c0.2-0.4,0.2-0.7,0.1-1C73.7,58.7,73.5,58,73.2,57.3z"
                    />
                    <path
                        class="st4"
                        d="M77.1,43.7c-0.6,0.1-1.2,0.2-1.8,0.4c-1.2,0.3-2.3,0.7-3.5,1c-0.2,0.1-0.3,0.2-0.2,0.4 c0.3,0.7,0.5,1.4,0.8,2.2c0.8,2.1,1.5,4.1,2.3,6.2c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0c0.2-3.5,1.2-6.9,2.5-10.2 C77.3,43.7,77.2,43.7,77.1,43.7z"
                    />
                    <path
                        class="st3"
                        d="M66.8,31.6c-0.3,0-0.4,0.1-0.3,0.4c0.3,0.7,0.5,1.4,0.8,2.2c0.5,1.3,1,2.7,1.5,4c0.5,1.4,1,2.7,1.5,4.1 c0.1,0.2,0.2,0.5,0.3,0.7c0.1,0.1,0.2,0.2,0.3,0.1c0.3-0.1,0.6-0.2,0.9-0.3c1.2-0.3,2.4-0.7,3.7-1c0.6-0.1,1.1-0.2,1.8-0.3 c0-0.1-0.1-0.2-0.1-0.3c-1-2.2-2.1-4.4-3.4-6.4c-0.7-1-1.4-2-2.3-2.9c-0.5-0.5-1.1-0.9-2-0.7C68.6,31.2,67.7,31.4,66.8,31.6z"
                    />
                    <path
                        class="st4"
                        d="M53.9,64.3C53.9,64.3,54,64.3,53.9,64.3c0-0.1,0-0.2,0-0.2c-0.6-1-1.2-2-1.9-3.1c-0.9-1.4-1.8-2.9-2.6-4.3 c-0.2-0.3-0.2-0.3-0.5-0.1c-1.5,1-2.9,2-4.2,3.2c-0.2,0.2-0.1,0.2,0.1,0.3c0.5,0.2,1.1,0.3,1.6,0.5c2.4,0.7,4.6,1.7,6.6,3 C53.2,63.9,53.6,64.1,53.9,64.3z"
                    />
                </g>
                <g>
                    <path
                        class="st5"
                        d="M152.5,178.7 L63.1,178.7 L63.1,68.3 L152.5,67.3z"
                    />
                    <path
                        class="st6"
                        d="M147.9,174.8 L63.1,174.8 L63.1,64.4 L147.9,63.4z"
                    />
                    <path
                        class="st6"
                        d="M100.9,63.6 L56.2,121.8 L56.2,169.8 L142,169.8 L142,63.6z"
                    />
                    <path
                        class="st6"
                        d="M62.9,63.9c0,0,1.7,53-38.7,83.4c0,0,38.1,21.8,94.4,31.7c0,0,35.3-38.8,29.7-115.3L62.9,63.9z"
                    />
                    <path
                        class="st7"
                        d="M83.7,70.7c-5,0-9.1-4.1-9.1-9.1s4.1-9.1,9.1-9.1s9.1,4.1,9.1,9.1c0,0.5-0.1,1.1-0.1,1.6h3.7 c0.1-0.5,0.1-1,0.1-1.6c0-7.1-5.7-12.8-12.8-12.8c-7.1,0-12.8,5.7-12.8,12.8c0,7.1,5.7,12.8,12.8,12.8V70.7z"
                    />
                    <path
                        class="st7"
                        d="M107.8,70.7c-5,0-9.1-4.1-9.1-9.1s4.1-9.1,9.1-9.1s9.1,4.1,9.1,9.1c0,0.5-0.1,1.1-0.1,1.6h3.7 c0.1-0.5,0.1-1,0.1-1.6c0-7.1-5.7-12.8-12.8-12.8c-7.1,0-12.8,5.7-12.8,12.8c0,7.1,5.7,12.8,12.8,12.8V70.7z"
                    />
                    <path
                        class="st7"
                        d="M133.4,70.7c-5,0-9.1-4.1-9.1-9.1s4.1-9.1,9.1-9.1c5,0,9.1,4.1,9.1,9.1c0,0.5-0.1,1.1-0.1,1.6h3.7 c0.1-0.5,0.1-1,0.1-1.6c0-7.1-5.7-12.8-12.8-12.8c-7.1,0-12.8,5.7-12.8,12.8c0,7.1,5.7,12.8,12.8,12.8V70.7z"
                    />
                    <g>
                        <path
                            class="st8"
                            d="M69.9,102.2c-1.1,3.9-2.6,8.1-4.5,12.5c21.3,1.6,45.3,3.5,67.3,5.2c0.9-3.9,1.7-9.3,2.3-13.9 C113.8,104.4,90.7,103.8,69.9,102.2z"
                        />
                        <path
                            class="st8"
                            d="M136.7,81.8L73.5,82c0,0-0.3,5.9-2.5,14.6c20.7,1.6,43.6,2.2,64.5,3.8C136.2,94.3,136.6,88.9,136.7,81.8z"
                        />
                    </g>
                </g>
                <g id="Nf8tVs.tif">
                    <g>
                        <path
                            class="st9"
                            d="M156.8,67c2.1,0.6,4.2,1.1,6.3,1.6c2.5,0.6,5,1.3,7.5,1.9c2.6,0.6,5.3,0.6,7.9,0c1.5-0.4,3.1-0.7,4.6-1 c0.1,0,0.2,0,0.3-0.1c0,0.1,0,0.2,0,0.3c-0.4,6.1-0.7,12.2-1.1,18.3c0,0.6-0.3,1-0.9,1.4c-0.8,0.5-1.8,0.8-2.7,1 c-1.7,0.4-3.4,0.6-5.2,0.6c-1.7,0-3.3,0-5-0.1c-3.1-0.2-6.1-0.6-9.1-1.5c-1.1-0.4-2.2-0.8-3.1-1.5c-0.5-0.4-0.7-0.9-0.7-1.4 c0.4-6.4,0.8-12.8,1.2-19.2C156.8,67.2,156.8,67.1,156.8,67z"
                        />
                        <path
                            class="st10"
                            d="M175.6,60.2c0.6-1.2,1.3-2.4,1.9-3.6c1.4-2.6,2.8-5.3,4.2-7.9c0.5-1,1.7-1.5,2.9-1.2c1.2,0.3,2,1.2,1.8,2.3 c-0.1,0.4-0.3,0.8-0.5,1.2c-1.8,3.4-3.6,6.8-5.4,10.3c0,0.1-0.1,0.1-0.1,0.2c0.9,0.2,1.8,0.5,2.7,0.7c1.8,0.5,3.6,0.9,5.4,1.4 c0.5,0.1,0.8,0.4,0.8,0.8c0,0.4-0.3,0.7-0.8,0.8c-3.8,0.8-7.6,1.7-11.5,2.5c-2.1,0.5-4.3,0.3-6.4-0.2c-5-1.3-10-2.6-15-3.9 c-1.1-0.3-2.2-0.6-3.3-0.9c-0.5-0.1-0.8-0.4-0.8-0.8c0-0.4,0.3-0.7,0.8-0.8c3.4-0.8,6.8-1.5,10.2-2.3c1.1-0.2,2.2-0.5,3.4-0.5 c1.5-0.1,2.9,0.1,4.3,0.5c1.7,0.5,3.4,0.9,5.2,1.3C175.4,60.2,175.5,60.2,175.6,60.2z M174.8,61.8c-0.4-0.1-0.7-0.1-1.1-0.2 c-1.7-0.1-3.4-0.3-5-0.4c-1.8-0.1-3.6,0-5.4,0.2c-0.8,0.1-1.6,0.2-2.2,0.6c-0.5,0.3-0.5,0.7,0,1c0.5,0.3,1.1,0.6,1.7,0.7 c1.5,0.5,3.2,0.8,4.8,0.9c1.8,0.2,3.6,0.2,5.4,0.4c0.1,0,0.2-0.1,0.3-0.2c0.1-0.2,0.2-0.4,0.4-0.7 C173.9,63.5,174.3,62.6,174.8,61.8z M178.8,64.6C178.8,64.6,178.8,64.6,178.8,64.6c0.5-0.1,0.9-0.2,1.2-0.5 c0.3-0.2,0.3-0.4,0.1-0.6c-0.1-0.2-0.3-0.3-0.5-0.5C179.3,63.6,179,64.1,178.8,64.6z"
                        />
                    </g>
                </g>
                <g id="wEzuwn.tif">
                    <g>
                        <path
                            class="st11"
                            d="M178.3,69.6c-11,20.3-21.9,40.6-32.9,60.8c1.2,0.5,2.5,0.9,3.6,1.4c8.2,4.2,10.4,15.2,4.3,22.2 c-5.6,6.5-15.3,6.8-21.3,0.8c-5-5-5.5-13.1-1.3-18.8c0.3-0.4,0.5-0.8,0.7-1.2c7.1-15.5,14.3-30.9,21.4-46.4c1.9-4,3.8-8,5.7-12 c1.1-2.2,2.5-4.2,4.5-5.7c2.6-2.1,5.7-2.9,9-2.7c1.9,0.1,3.8,0.5,5.6,1.2C177.8,69.4,178.1,69.5,178.3,69.6z M136.1,149 c2.4,3.4,7.2,4.3,10.6,1.9c3.4-2.4,4.3-7.1,1.9-10.6c-2.4-3.4-7.2-4.3-10.6-1.9C134.6,140.8,133.7,145.6,136.1,149z M149.3,114 c-0.9-1.3-2.7-1.7-4-0.8c-1.3,0.9-1.7,2.8-0.8,4.1c0.9,1.3,2.7,1.6,4.1,0.7C149.9,117.2,150.3,115.4,149.3,114z"
                        />
                        <path
                            class="st12"
                            d="M201.3,102.7c0.1,1.7,0,3.3-0.4,5c-0.6,2.8-1.8,5.3-3.9,7.3c-1.7,1.7-3.8,2.7-6.1,3.3 c-2.4,0.7-4.9,0.7-7.4,0.9c-10.3,0.8-20.6,1.6-30.8,2.4c-0.1,0-0.2,0-0.3,0c0.2-0.3,0.3-0.6,0.4-0.9c2.1-4,4.3-7.9,6.4-11.9 c0.2-0.3,0.4-0.4,0.7-0.5c13.7-1.9,27.4-3.8,41.1-5.7C201.1,102.8,201.2,102.8,201.3,102.7z"
                        />
                        <path
                            class="st12"
                            d="M132.5,112.3c2.5-0.4,5-0.7,7.6-1.1c-0.1,0.2-0.1,0.3-0.1,0.4c-1.7,3.6-3.4,7.3-5,10.9 c-0.1,0.3-0.3,0.4-0.6,0.4c-3.6,0.3-7.2,0.5-10.8,0.8c-1.1,0.1-2.2,0.5-3.3,0.6c-5.7,0.8-11.4-1.9-14.4-6.8 c-3.5-5.8-2.6-13.1,2.2-17.9c5.7-5.6,14.9-5.5,20.4,0.1c3.2,3.3,4.5,7.3,4.1,11.8C132.5,111.9,132.5,112.1,132.5,112.3z M113.8,104c-3.5,2.4-4.3,7.1-1.9,10.6c2.4,3.4,7.1,4.3,10.6,1.9c3.5-2.4,4.3-7.2,1.8-10.7C121.9,102.4,117.2,101.6,113.8,104z"
                        />
                    </g>
                </g>
                <path
                    class="st10"
                    d="M57,48c0.6,0.2,1.1,0.4,1.8,0.5c-0.1,0.2-0.2,0.3-0.2,0.5c-0.1,0.1,0,0.2,0.1,0.2c0.5,0,1,0.1,1.4,0.4 c0.2,0.1,0.2,0,0.2-0.1c0.3-0.7,0.6-1.5,0.9-2.2c0.2-0.4,0.3-0.8,0.5-1.2c0-0.1,0-0.2,0-0.3c-0.1-0.2-0.3-0.5-0.4-0.7 c-0.1-0.1-0.1-0.2-0.3-0.1c-0.5,0.3-1,0.5-1.6,0.5c-0.4,0-0.9,0-1.2-0.4c-0.3-0.3-0.3-0.6-0.2-1c0.3-0.7,0.5-1.3,0.8-2 c0.9-2.1,3.9-2.8,5.5-1.4c0.9,0.9,1.2,1.9,0.7,3.2c-0.2,0.6-0.5,1.3-0.8,1.9c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.3,0.2-0.3,0.4 c-0.8,1.9-1.5,3.7-2.3,5.6c-0.4,0.9-0.9,1.5-1.9,1.9c-1,0.4-2.4,0.2-3-0.6c-0.7-0.8-0.8-1.7-0.4-2.7C56.1,50,56.5,49,57,48 C56.9,48.1,56.9,48,57,48z M60.9,43.2c0.2,0.5,0.9,0.6,1.4,0.4c0.5-0.2,0.8-0.9,0.6-1.3c-0.2-0.5-0.9-0.7-1.4-0.4 C61,42.1,60.7,42.8,60.9,43.2z M58,51c-0.5,0.2-0.7,0.8-0.5,1.2c0.2,0.4,0.8,0.6,1.2,0.3c0.5-0.2,0.7-0.8,0.5-1.2 C59,50.9,58.4,50.8,58,51z"
                />
            </svg>
        )
    }

    get browse() {
        return (
            <svg viewBox="0 0 28 22" focusable="false">
                <path
                    class="st0"
                    d="M7.5,19h17c0.276,0,0.5-0.224,0.5-0.5S24.776,18,24.5,18h-17C7.224,18,7,18.224,7,18.5S7.224,19,7.5,19z M8,4h6v8H8V4z M7.5,13h7c0.276,0,0.5-0.224,0.5-0.5v-9C15,3.224,14.776,3,14.5,3h-7C7.224,3,7,3.224,7,3.5v9C7,12.776,7.224,13,7.5,13zM27,21H3c-1.105,0-2-0.896-2-2V5h3v13.5C4,18.776,4.224,19,4.5,19S5,18.776,5,18.5V1h22V21z M27,0H5C4.448,0,4,0.447,4,1v3H1C0.448,4,0,4.447,0,5v14c0,1.656,1.343,3,3,3h24c0.552,0,1-0.448,1-1V1C28,0.447,27.552,0,27,0z M7.5,16h17c0.276,0,0.5-0.224,0.5-0.5S24.776,15,24.5,15h-17C7.224,15,7,15.224,7,15.5S7.224,16,7.5,16z M17.5,7h7C24.776,7,25,6.776,25,6.5S24.776,6,24.5,6h-7C17.224,6,17,6.224,17,6.5S17.224,7,17.5,7z M17.5,13h7c0.276,0,0.5-0.224,0.5-0.5S24.776,12,24.5,12h-7c-0.276,0-0.5,0.224-0.5,0.5S17.224,13,17.5,13z M17.5,4h7C24.776,4,25,3.776,25,3.5S24.776,3,24.5,3h-7C17.224,3,17,3.224,17,3.5S17.224,4,17.5,4z M17.5,10h7c0.276,0,0.5-0.224,0.5-0.5S24.776,9,24.5,9h-7C17.224,9,17,9.224,17,9.5S17.224,10,17.5,10z"
                />
            </svg>
        )
    }

    get clip() {
        return (
            <svg viewBox="0 0 28 26" focusable="false">
                <path
                    class="st0"
                    d="M26.545,22.535c-0.277,0.198-0.723,0.423-1.376,0.482c-1.429,0.126-3.974-0.528-8.012-4.388c-1.153-1-2.161-1.88-3.072-2.675c-0.374-0.326-0.724-0.63-1.066-0.927l1.83-1.392L26.545,22.535z M7.382,18.056c-0.001,0-0.001-0.001-0.002-0.001l-0.829,0.63c0,0,0.001,0.001,0.001,0.002c0.132,0.096,0.256,0.202,0.372,0.316c0.012,0.011,0.023,0.024,0.035,0.035c0.111,0.112,0.217,0.23,0.312,0.356l0.001-0.001C7.725,19.979,8,20.708,8,21.506c0,1.931-1.567,3.495-3.5,3.495S1,23.437,1,21.506c0-1.361,0.787-2.528,1.924-3.105l0.16-0.108c3.787-2.112,5.989-3.858,11.001-8.227c0.91-0.793,1.919-1.673,3.072-2.671c4.038-3.855,6.583-4.509,8.012-4.383c0.653,0.059,1.099,0.284,1.376,0.481L7.382,18.056z M3.987,8.231L3.969,8.219l-1.045-0.61C1.787,7.031,1,5.863,1,4.5C1,2.567,2.567,1,4.5,1S8,2.567,8,4.5c0,0.799-0.275,1.528-0.727,2.115L7.272,6.615C7.176,6.74,7.07,6.859,6.959,6.971C6.948,6.983,6.937,6.995,6.924,7.007c-0.116,0.114-0.24,0.22-0.372,0.316c0,0-0.001,0-0.001,0.001L7.38,7.956c0.001,0,0.001-0.001,0.002-0.001l4.052,3.083c-0.559,0.479-1.078,0.918-1.568,1.325C7.74,10.629,6.07,9.447,3.987,8.231zM27.994,3.648l-0.271-0.392c-0.029-0.044-0.752-1.062-2.411-1.232c-2.386-0.244-5.359,1.321-8.828,4.633c-1.136,0.983-2.145,1.863-3.056,2.657c-0.429,0.375-0.83,0.721-1.219,1.057L8.076,7.226C8.655,6.469,9,5.526,9,4.5C9,2.014,6.985,0,4.5,0S0,2.014,0,4.5c0,1.757,1.01,3.275,2.477,4.016L2.474,8.521c2.494,1.385,4.23,2.558,6.605,4.488c-2.377,1.928-4.11,3.096-6.605,4.481l0.003,0.004C1.01,18.236,0,19.751,0,21.506C0,23.988,2.014,26,4.5,26S9,23.988,9,21.506c0-1.024-0.345-1.968-0.924-2.724l4.128-3.137c0.39,0.337,0.79,0.685,1.223,1.062c0.911,0.795,1.92,1.676,3.056,2.66c3.469,3.316,6.442,4.885,8.828,4.64c1.659-0.169,2.382-1.19,2.411-1.233l0.271-0.393l-12.318-9.373L27.994,3.648z M12.344,12.5c-0.276,0-0.5,0.224-0.5,0.5c0,0.276,0.224,0.5,0.5,0.5c0.276,0,0.5-0.224,0.5-0.5C12.844,12.724,12.62,12.5,12.344,12.5zM4.5,22.504c-0.552,0-1-0.447-1-0.998c0-0.552,0.448-0.999,1-0.999c0.552,0,1,0.447,1,0.999C5.5,22.057,5.052,22.504,4.5,22.504zM4.5,19.508c-1.105,0-2,0.895-2,1.998c0,1.103,0.895,1.997,2,1.997s2-0.895,2-1.997C6.5,20.403,5.604,19.508,4.5,19.508z M4.5,5.5c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1c0.552,0,1,0.448,1,1C5.5,5.052,5.052,5.5,4.5,5.5z M4.5,2.5c-1.105,0-2,0.896-2,2s0.895,2,2,2s2-0.896,2-2S5.604,2.5,4.5,2.5z"
                />
            </svg>
        )
    }

    get find() {
        return (
            <svg viewBox="0 0 28 28" focusable="false">
                <path d="M11.497,22.011C5.7,22.011,1,17.307,1,11.506C1,5.704,5.7,1.001,11.497,1.001s10.497,4.703,10.497,10.505C21.994,17.307,17.294,22.011,11.497,22.011z M27.841,27.161l-7.881-7.887c1.878-2.048,3.034-4.769,3.034-7.768C22.994,5.152,17.847,0,11.497,0C5.148,0,0,5.152,0,11.506s5.148,11.505,11.497,11.505c2.996,0,5.716-1.157,7.762-3.036l7.881,7.887c0.193,0.194,0.507,0.194,0.701,0C28.034,27.668,28.034,27.354,27.841,27.161z" />
            </svg>
        )
    }

    get toast_ok() {
        return (
            <svg viewBox="0 0 21 21" focusable="false">
                <g
                    id="accounts#2"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                >
                    <g
                        id="success-toast"
                        transform="translate(-444.000000, -60.000000)"
                        fill="#4A4A4A"
                    >
                        <g
                            id="toast"
                            transform="translate(196.000000, 48.000000)"
                        >
                            <path
                                d="M262.455219,17.9521875 C262.140875,17.7684375 261.739906,17.88 261.558781,18.1884375 L257.362063,25.4596875 L255.014,23.2940625 C254.765938,23.0315625 254.350531,23.0184375 254.086063,23.2678125 C253.821594,23.510625 253.807813,23.930625 254.055875,24.193125 L257.05625,26.9625 C257.303656,27.225 257.719063,27.238125 257.983531,26.98875 C258.063594,26.9165625 262.695406,18.8446875 262.695406,18.8446875 C262.876531,18.53625 262.768906,18.129375 262.455219,17.9521875 L262.455219,17.9521875 Z M258.5,31.6875 C253.425875,31.6875 249.3125,27.5728125 249.3125,22.5 C249.3125,17.4271875 253.425875,13.3125 258.5,13.3125 C263.574125,13.3125 267.6875,17.4271875 267.6875,22.5 C267.6875,27.5728125 263.574125,31.6875 258.5,31.6875 L258.5,31.6875 Z M258.5,12 C252.701375,12 248,16.69875 248,22.5 C248,28.30125 252.701375,33 258.5,33 C264.298625,33 269,28.30125 269,22.5 C269,16.69875 264.298625,12 258.5,12 L258.5,12 Z"
                                id="Fill-22"
                            ></path>
                        </g>
                    </g>
                </g>
            </svg>
        )
    }

    get toast_error() {
        return (
            <svg viewBox="0 0 35 35" version="1.1">
                <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                >
                    <g
                        transform="translate(-586.000000, -8.000000)"
                        stroke="#FFFFFF"
                        stroke-width="1.5"
                    >
                        <g transform="translate(587.000000, 9.000000)">
                            <path
                                d="M23.4230769,9.5 L9.57692308,23.5"
                                stroke-linecap="square"
                            ></path>
                            <path
                                d="M23.4230769,9.5 L9.57692308,23.5"
                                stroke-linecap="square"
                                transform="translate(16.500000, 16.500000) scale(-1, 1) translate(-16.500000, -16.500000) "
                            ></path>
                            <circle cx="16.5" cy="16.5" r="16.5"></circle>
                        </g>
                    </g>
                </g>
            </svg>
        )
    }

    get printer() {
        return (
            <svg viewBox="0 0 25 25">
                <g data-name="Layer 2">
                    <g>
                        <circle fill="#97c95d" cx="11" cy="11" r="11" />
                        <path fill="none" d="M5,3H29V27H5Z" />
                        <path
                            fill="#ffffff"
                            d="M15.55,8.4H6.45a2,2,0,0,0-1.95,2v3.9H7.1v2.6h7.8v-2.6h2.6v-3.9A2,2,0,0,0,15.55,8.4Zm-2,7.15H8.4V12.3h5.2Zm2-4.55a.65.65,0,1,1,.65-.65A.65.65,0,0,1,15.55,11ZM14.9,5.15H7.1v2.6h7.8Z"
                        />
                    </g>
                </g>
            </svg>
        )
    }

    get printerNew() {
        return (
            <svg width="14px" height="13px" viewBox="0 0 14 13" version="1.1">
                <g
                    id="Symbols"
                    stroke="none"
                    stroke-width="1"
                    fill-rule="evenodd"
                >
                    <g
                        id="icon-print-grey"
                        transform="translate(-5.000000, -6.000000)"
                    >
                        <path
                            d="M7.8,8.8 L16.2,8.8 L16.2,6 L7.8,6 L7.8,8.8 Z M16.9,12.3 C16.515,12.3 16.2,11.985 16.2,11.6 C16.2,11.215 16.515,10.9 16.9,10.9 C17.285,10.9 17.6,11.215 17.6,11.6 C17.6,11.985 17.285,12.3 16.9,12.3 L16.9,12.3 Z M9.2,17.2 L14.8,17.2 L14.8,13.7 L9.2,13.7 L9.2,17.2 Z M16.9,9.5 L7.1,9.5 C5.938,9.5 5,10.438 5,11.6 L5,15.8 L7.8,15.8 L7.8,18.6 L16.2,18.6 L16.2,15.8 L19,15.8 L19,11.6 C19,10.438 18.062,9.5 16.9,9.5 L16.9,9.5 Z"
                            id="Page-1"
                        ></path>
                    </g>
                </g>
            </svg>
        )
    }

    get plus() {
        return (
            <svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1">
                <g stroke="none" stroke-width="1" fill-rule="evenodd">
                    <g transform="translate(-419.000000, -288.000000)">
                        <g transform="translate(399.000000, 149.000000)">
                            <g transform="translate(2.000000, 59.000000)">
                                <g transform="translate(18.000000, 80.000000)">
                                    <rect
                                        x="6.5"
                                        y="0"
                                        width="2"
                                        height="15"
                                    ></rect>
                                    <rect
                                        transform="translate(7.500000, 7.500000) rotate(-270.000000) translate(-7.500000, -7.500000) "
                                        x="6.5"
                                        y="3.55271368e-15"
                                        width="2"
                                        height="15"
                                    ></rect>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        )
    }

    get checkmark() {
        return (
            <svg version="1.1" viewBox="0 0 10.8 8.6">
                <g>
                    <rect
                        x="0"
                        y="4.7"
                        transform="matrix(0.6917 0.7222 -0.7222 0.6917 4.9394 -0.1815)"
                        width="5.4"
                        height="2"
                    />
                    <rect
                        x="1.8"
                        y="3.3"
                        transform="matrix(0.7195 -0.6945 0.6945 0.7195 -1.0963 5.7845)"
                        width="9.6"
                        height="2"
                    />
                </g>
            </svg>
        )
    }

    get garbage() {
        return (
            <svg width="14px" height="18px" viewBox="0 0 14 18" version="1.1">
                <g
                    id="Symbols"
                    stroke="none"
                    stroke-width="1"
                    fill-rule="evenodd"
                >
                    <g
                        id="icon-delete"
                        transform="translate(-5.000000, -3.000000)"
                    >
                        <g
                            id="edit-delete"
                            transform="translate(5.000000, 3.000000)"
                        >
                            <path
                                d="M0.872463768,3.02318841 L1.70434783,16.0898551 C1.74492754,16.8 2.37391304,17.3478261 3.10434783,17.3478261 L10.7333333,17.3478261 C11.484058,17.3478261 12.0927536,16.8 12.1333333,16.0898551 L12.9652174,3.02318841 L0.872463768,3.02318841 Z"
                                id="Fill-1"
                            ></path>
                            <path
                                d="M13.3913855,0.994243478 L9.82016812,0.994243478 L9.69863188,0.304388406 C9.67813913,0.142069565 9.53631304,4.05797101e-05 9.35370435,4.05797101e-05 L4.5448058,4.05797101e-05 C4.3624,4.05797101e-05 4.22037101,0.142069565 4.1797913,0.324678261 L4.07834203,0.994243478 L0.446457971,0.994243478 C0.20297971,0.994243478 8.11594205e-05,1.19714203 8.11594205e-05,1.44062029 L8.11594205e-05,1.96815652 C8.11594205e-05,2.21163478 0.20297971,2.41453333 0.446457971,2.41453333 L13.3913855,2.41453333 C13.6346609,2.41453333 13.8375594,2.21163478 13.8375594,1.96815652 L13.8375594,1.44062029 C13.8375594,1.19714203 13.6346609,0.994243478 13.3913855,0.994243478"
                                id="Fill-3"
                            ></path>
                        </g>
                    </g>
                </g>
            </svg>
        )
    }

    get combine() {
        return (
            <svg viewBox="0 0 75.5 50.8">
                <g>
                    <circle cx="21.4" cy="15.4" r="8.2" />
                </g>
                <path d="M1.7,46.7h41.9c0,0-0.2-16.9-20.9-16.9C2.3,29.8,1.7,46.7,1.7,46.7z" />
                <path d="M51.4,29.6c-4,0-7.1,1-9.5,2.3c8.4,4.6,8.5,14.8,8.5,14.8h19.2C69.6,46.7,69.5,29.6,51.4,29.6z" />
                <g>
                    <circle cx="49" cy="15.3" r="8.2" />
                </g>
            </svg>
        )
    }

    get combinePlus() {
        return (
            <svg width="24px" height="13px" viewBox="0 0 24 13" version="1.1">
                <g
                    id="Symbols"
                    stroke="none"
                    stroke-width="1"
                    fill-rule="evenodd"
                >
                    <g
                        id="icon-share-grey"
                        transform="translate(0.000000, -6.000000)"
                    >
                        <path
                            d="M13,14 C11,14 7,15 7,17 L7,19 L19,19 L19,17 C19,15 15,14 13,14 L13,14 Z M19.62,14.16 C20.45,14.89 21,15.82 21,17 L21,19 L24,19 L24,17 C24,15.46 21.63,14.51 19.62,14.16 L19.62,14.16 Z M13,12 C14.66,12 15.99,10.66 15.99,9 C15.99,7.34 14.66,6 13,6 C11.34,6 10,7.34 10,9 C10,10.66 11.34,12 13,12 L13,12 Z M18,12 C19.66,12 20.99,10.66 20.99,9 C20.99,7.34 19.66,6 18,6 C17.68,6 17.37,6.05 17.09,6.14 C17.66,6.95 17.99,7.93 17.99,9 C17.99,10.07 17.65,11.04 17.09,11.86 C17.37,11.95 17.68,12 18,12 L18,12 Z M8,11 L5,11 L5,8 L3,8 L3,11 L0,11 L0,13 L3,13 L3,16 L5,16 L5,13 L8,13 L8,11 Z"
                            id="Page-1"
                        ></path>
                    </g>
                </g>
            </svg>
        )
    }

    get share() {
        return (
            <svg version="1.1" viewBox="0 0 30 26">
                <g>
                    <path
                        class="st1"
                        d="M10.8,7.7l3.3-4L14,18c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1l0-14.3l3.3,4c0.4,0.4,1,0.4,1.4,0c0.4-0.4,0.4-1,0-1.4l-4.9-6C15.6,0.1,15.3,0,15.1,0c-0.3,0-0.6,0.1-0.8,0.3l-5,6C9,6.7,9,7.3,9.4,7.7C9.7,8.1,10.4,8.1,10.8,7.7z M1,26L29,26c0.6,0,1-0.4,1-1l0-8c0-0.6-0.4-1-1-1s-1,0.4-1,1l0,7L2,24l0-7c0-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1l0,8C0,25.5,0.4,26,1,26z"
                    />
                </g>
            </svg>
        )
    }

    get paperclip() {
        return (
            <svg x="0px" y="0px" viewBox="0 0 31 31">
                <g>
                    <g>
                        <path
                            fill="#4A4A4A"
                            d="M6.9,28.4c-0.8,0.8-2.1,0.8-2.9,0l-1.4-1.4c-0.8-0.8-0.8-2.1,0-2.9l9.6-9.6c-1.3-0.4-2.8,0-3.9,1l-7.2,7.2c-1.6,1.6-1.6,4.1,0,5.7l1.4,1.4c1.6,1.6,4.1,1.6,5.7,0l7.2-7.2c1.1-1.1,1.4-2.5,1-3.9L6.9,28.4z M18.7,12.3c-0.4-0.4-1-0.4-1.4,0l-5,5c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l5-5C19.1,13.3,19.1,12.7,18.7,12.3z M29.8,2.6l-1.4-1.4c-1.6-1.6-4.1-1.6-5.7,0l-7.2,7.2c-1.1,1.1-1.4,2.5-1,3.9l9.6-9.6c0.8-0.8,2.1-0.8,2.9,0L28.4,4c0.8,0.8,0.8,2.1,0,2.9l-9.6,9.6c1.3,0.4,2.8,0,3.9-1l7.2-7.2C31.4,6.8,31.4,4.2,29.8,2.6z"
                        />
                    </g>
                </g>
            </svg>
        )
    }

    get rubikCube() {
        return (
            <svg id="Layer_1" viewBox="0 0 32.7 32.6">
                <path d="M7.8 8.3h-7c-.3 0-.5-.2-.5-.5v-7C.3.5.5.3.8.3h7c.3 0 .5.2.5.5v7c0 .3-.2.5-.5.5zM19.8 8.3h-7c-.3 0-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v7c0 .3-.2.5-.5.5zM31.8 8.3h-7c-.3 0-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v7c0 .3-.2.5-.5.5zM7.8 20.3h-7c-.3 0-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v7c0 .3-.2.5-.5.5zM19.8 20.3h-7c-.3 0-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v7c0 .3-.2.5-.5.5zM31.8 20.3h-7c-.3 0-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v7c0 .3-.2.5-.5.5zM31.8 32.3h-7c-.3 0-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v7c0 .3-.2.5-.5.5zM19.8 32.3h-7c-.3 0-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v7c0 .3-.2.5-.5.5zM7.8 32.3h-7c-.3 0-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v7c0 .3-.2.5-.5.5z" />
            </svg>
        )
    }

    get scissors() {
        return (
            <svg width="14px" height="14px" viewBox="0 0 14 14">
                <defs></defs>
                <g stroke="none" stroke-width="1" fill-rule="evenodd">
                    <g transform="translate(-5.000000, -5.000000)">
                        <g transform="translate(5.000000, 5.000000)">
                            <path
                                d="M5.348,3.948 C5.509,3.598 5.6,3.213 5.6,2.8 C5.6,1.253 4.347,0 2.8,0 C1.253,0 0,1.253 0,2.8 C0,4.347 1.253,5.6 2.8,5.6 C3.213,5.6 3.598,5.509 3.948,5.348 L5.6,7 L3.948,8.652 C3.598,8.491 3.213,8.4 2.8,8.4 C1.253,8.4 0,9.653 0,11.2 C0,12.747 1.253,14 2.8,14 C4.347,14 5.6,12.747 5.6,11.2 C5.6,10.787 5.509,10.402 5.348,10.052 L7,8.4 L11.9,13.3 L14,13.3 L14,12.6 L5.348,3.948 Z M2.8,4.2 C2.03,4.2 1.4,3.577 1.4,2.8 C1.4,2.023 2.03,1.4 2.8,1.4 C3.57,1.4 4.2,2.023 4.2,2.8 C4.2,3.577 3.57,4.2 2.8,4.2 Z M2.8,12.6 C2.03,12.6 1.4,11.977 1.4,11.2 C1.4,10.423 2.03,9.8 2.8,9.8 C3.57,9.8 4.2,10.423 4.2,11.2 C4.2,11.977 3.57,12.6 2.8,12.6 Z M7,7.35 C6.804,7.35 6.65,7.196 6.65,7 C6.65,6.804 6.804,6.65 7,6.65 C7.196,6.65 7.35,6.804 7.35,7 C7.35,7.196 7.196,7.35 7,7.35 Z M11.9,0.7 L7.7,4.9 L9.1,6.3 L14,1.4 L14,0.7 L11.9,0.7 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </g>
            </svg>
        )
    }

    get user() {
        return (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V18.88C3 16.18 5.81 14 9.33 14H14.67C18.16 14 21 16.24 21 19V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22ZM5 20H19V19C19 17.37 17 16 14.67 16H9.33C7 16 5 17.34 5 19V20Z"
                    fill="#0F72EA"
                />
                <path
                    d="M12 12C11.0111 12 10.0444 11.7068 9.22215 11.1573C8.39991 10.6079 7.75904 9.82705 7.3806 8.91342C7.00217 7.99979 6.90315 6.99446 7.09608 6.02455C7.289 5.05465 7.76521 4.16373 8.46447 3.46447C9.16373 2.76521 10.0546 2.289 11.0246 2.09608C11.9945 1.90315 12.9998 2.00217 13.9134 2.3806C14.827 2.75904 15.6079 3.39991 16.1574 4.22215C16.7068 5.0444 17 6.0111 17 7C17 7.65661 16.8707 8.30679 16.6194 8.91342C16.3681 9.52005 15.9998 10.0712 15.5355 10.5355C15.0712 10.9998 14.52 11.3681 13.9134 11.6194C13.3068 11.8707 12.6566 12 12 12ZM12 4C11.4067 4 10.8266 4.17595 10.3333 4.50559C9.83994 4.83524 9.45543 5.30377 9.22836 5.85195C9.0013 6.40013 8.94189 7.00333 9.05765 7.58527C9.1734 8.16722 9.45912 8.70177 9.87868 9.12132C10.2982 9.54088 10.8328 9.8266 11.4147 9.94236C11.9967 10.0581 12.5999 9.9987 13.1481 9.77164C13.6962 9.54458 14.1648 9.16006 14.4944 8.66671C14.8241 8.17337 15 7.59335 15 7C15 6.20435 14.6839 5.44129 14.1213 4.87868C13.5587 4.31607 12.7957 4 12 4Z"
                    fill="#0F72EA"
                />
            </svg>
        )
    }

    get CCPA_error() {
        return (
            <svg width="20" height="16" viewBox="0 0 20 16" fill="none">
                <path
                    d="M19 16.0001H0.999999C0.820632 15.9998 0.644646 15.9513 0.490484 15.8596C0.336322 15.7679 0.209659 15.6364 0.123768 15.479C0.0378771 15.3215 -0.00407944 15.1438 0.00229503 14.9646C0.00866951 14.7853 0.0631404 14.6111 0.159999 14.4601L9.16 0.460099C9.25065 0.319752 9.37503 0.204356 9.52177 0.124453C9.6685 0.0445493 9.83292 0.00268555 10 0.00268555C10.1671 0.00268555 10.3315 0.0445493 10.4782 0.124453C10.625 0.204356 10.7493 0.319752 10.84 0.460099L19.84 14.4601C19.9369 14.6111 19.9913 14.7853 19.9977 14.9646C20.0041 15.1438 19.9621 15.3215 19.8762 15.479C19.7903 15.6364 19.6637 15.7679 19.5095 15.8596C19.3554 15.9513 19.1794 15.9998 19 16.0001ZM2.83 14.0001H17.17L10 2.8501L2.83 14.0001Z"
                    fill="#990026"
                />
                <path
                    d="M10 10C9.73478 10 9.48043 9.89464 9.29289 9.70711C9.10536 9.51957 9 9.26522 9 9V7C9 6.73478 9.10536 6.48043 9.29289 6.29289C9.48043 6.10536 9.73478 6 10 6C10.2652 6 10.5196 6.10536 10.7071 6.29289C10.8946 6.48043 11 6.73478 11 7V9C11 9.26522 10.8946 9.51957 10.7071 9.70711C10.5196 9.89464 10.2652 10 10 10Z"
                    fill="#990026"
                />
                <path
                    d="M10 13C10.5523 13 11 12.5523 11 12C11 11.4477 10.5523 11 10 11C9.44772 11 9 11.4477 9 12C9 12.5523 9.44772 13 10 13Z"
                    fill="#990026"
                />
            </svg>
        )
    }

    get seeInWeeklyAd_arrow() {
        return (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                    d="M6.66672 13.3332C6.40648 13.3332 6.17003 13.1818 6.06116 12.9455C5.95228 12.7091 5.9909 12.431 6.16005 12.2332L9.78672 7.99988L6.16005 3.76655C5.92073 3.48673 5.95356 3.06587 6.23339 2.82655C6.51321 2.58723 6.93406 2.62006 7.17339 2.89988L11.1734 7.56655C11.3868 7.81603 11.3868 8.18373 11.1734 8.43322L7.17339 13.0999C7.04672 13.248 6.86159 13.3332 6.66672 13.3332Z"
                    fill="#0F72EA"
                />
            </svg>
        )
    }
}

// Public Definitions -------------------------------------------------------->

export const icons = new Icons()
